import React from "react";

interface OrganizationContactInfoProps {
  formData: {
    contactPerson: string;
    contactPhone: string;
    contactEmail: string;
    notes: string;
  };
  handleInputChange: (field: string, value: string) => void;
}

const OrganizationContactInfo: React.FC<OrganizationContactInfoProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      {/* Contact Person Section - Three Columns */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
        {/* Người đầu mối */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Người đầu mối
          </label>
          <input
            type="text"
            value={formData.contactPerson}
            onChange={(e) => handleInputChange("contactPerson", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Nhập tên người đầu mối..."
          />
        </div>

        {/* Điện thoại */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Điện thoại
          </label>
          <input
            type="tel"
            value={formData.contactPhone}
            onChange={(e) => handleInputChange("contactPhone", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Điện thoại..."
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            value={formData.contactEmail}
            onChange={(e) => handleInputChange("contactEmail", e.target.value)}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Email..."
          />
        </div>
      </div>

      {/* Notes Section - Full Width */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Ghi chú
        </label>
        <textarea
          value={formData.notes || ""}
          onChange={(e) => handleInputChange("notes", e.target.value)}
          rows={4}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Ghi chú..."
        />
      </div>
    </div>
  );
};

export default OrganizationContactInfo;
